import styled from "styled-components";
import { DailySettlementSectionWrapper } from "../../../../daily-settlement/style";

export const MonthSettlementClosingWrapper = styled(
  DailySettlementSectionWrapper
)`
  display: grid;
  row-gap: 18px;
  column-gap: 10px;

  .a {
    grid-row: 1 / 3;
  }

  .b {
    grid-row: 1;
    grid-column: 2;
  }

  .c {
    grid-row: 2;
    grid-column: 2;
  }
`;

export const MonthSettlementClosingBorder = styled.div`
  border-bottom: 1px solid #d9d9d9;
  width: 100%;
  height: 0px;
`;

export const MonthSettlementClosingTextWrapper = styled.div<{
  marginTop?: string;
  size?: string;
}>`
  display: flex;
  flex-direction: column;
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : "0")};
  gap: 10px;

  > .text {
    display: flex;
    justify-content: space-between;
    font-family: Pretendard;
    font-weight: 500;
    font-size: ${({ size }) => (size ? size : "19px")};
    color: #121212;

    > .value {
      font-weight: 700;
      text-align: right;
    }
  }
`;

export const MonthSettlementClosingPoetryHeader = styled.div`
  display: flex;
  justify-content: space-between;

  > .button {
    cursor: pointer;
    padding: 0 10px;
    height: 27px;
    border-radius: 15px;
    background: #7f25fb;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 14px;
    line-height: 27px;
    color: #fff;
    text-align: center;
  }
`;

export const MonthSettlementClosingPoetryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 20px;
`;

export const MonthSettlementClosingBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MonthSettlementClosingBox = styled.div`
  width: 100%;
  height: 87px;
  border-radius: 8px;
  padding: 20px 16px;
  box-sizing: border-box;
  background: #ecf0f3;
  display: flex;
  flex-direction: column;
  gap: 5px;

  font-family: Pretendard;
  font-weight: 700;
  font-size: 15px;
  text-align: right;

  > .value {
    font-size: 20px;
  }
`;

export const MonthSettlementClosingHeader = styled.div`
  display: flex;
  gap: 14px;

  > .box {
    > .name {
      display: flex;
      justify-content: flex-start;
      gap: 6px;

      > img {
        width: 21px;
        height: 21px;
      }
    }

    > .value {
      display: flex;
      justify-content: flex-end;
      gap: 8px;

      > span {
        width: 108px;
        height: 41px;
        border-radius: 12px;
        background: #ff0000;
        font-weight: 700;
        font-size: 24px;
        line-height: 41px;
        text-align: center;
      }
    }
  }
`;
